module.exports = __webpack_public_path__ + "static/media/back.f5cda60d.svg";